// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/post-analytics-request-schema',
  type: 'object',
  required: ['companyId', 'analyticEventTypeId', 'clientIdentifier', 'eventIdentifier'],
  properties: {
    companyId: {
      type: 'integer',
    },
    analyticEventTypeId: {
      type: 'string',
      minLength: 1,
    },
    clientIdentifier: {
      type: 'string',
      minLength: 1,
    },
    eventIdentifier: {
      type: 'string',
      format: 'uuid',
    },
  },
} as IJSONSchema;

export default schema;
